import { gql } from 'graphql-request';

const Branding = gql`
  fragment Branding on SiteBranding {
    siteLogo {
      md: rendition(height: 150) {
        url
      }
      sm: rendition(height: 75) {
        url
      }
      title
    }
  }
`;
export default Branding;
